<template>
  <div class="dx-turn">
    <p>
      {{ $t('giveThePhoneToPlayer') }}
    </p>
    <div class="dx-turn__player">
      <dx-player
        :avatar="player.avatar"
        :points="player.points"
        :user="player.user"
        :mediator="true"
        />
    </div>
    <br>
    <dx-button primary large @click.native="$emit('click')">
      {{ $t('itsMe') }}
    </dx-button>
  </div>
</template>

<script>
import { DxPlayer, DxButton } from './'
export default {
  name: 'dx-turn',
  components: { DxPlayer, DxButton },
  props: {
    player: Object
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxTurn.vue